/* *@Description: '三方下单' *@ComponentAuthor: wsr */
<template>
  <div class="main-wrap externalOrder">
    <div class="externalOrder-top">
      <div class="search-btns">
        <el-form :inline="true">
          <el-form-item v-if="exportStatus === 'already_print' || exportStatus === 'wait_print'">
            <print
              ref="printOrder"
              :typeName="'oneAndtwoLinkPage'"
              :getPrintData="getPrintData"
              :options="printOptions"
              :hasPower="true"
              :isDisabled="multipleSelection.length > 0 ? false : true"
            ></print>
          </el-form-item>
          <!-- 2002-4-7 隐藏导出功能 -->
          <!-- <el-form-item>
            <el-button type="primary" icon="iconfont icondaochu" @click="exportOpen" :loading="exportLoading" class="h40" plain>{{ $lang('导出') }}</el-button>
          </el-form-item>
          <el-form-item>
            <el-button icon="iconfont icondaochu" type="primary" @click="dialogExportDownVisible = true" class="h40" plain>{{ $lang('下载中心') }}</el-button>
          </el-form-item> -->
        </el-form>
      </div>
      <div class="search-condition" id="jmsSearch">
        <el-form :model="searchParam" ref="seach" :inline="true">
          <el-form-item prop="date">
            <el-date-picker
              :clearable="false"
              v-model="searchParam.date"
              type="daterange"
              :range-separator="$lang('至')"
              :start-placeholder="$lang('开始时间')"
              :end-placeholder="$lang('结束时间')"
              class="commonSize"
              @change="selectDate"
              :default-time="['00:00:00', '23:59:59']"
              value-format="yyyy-MM-dd HH:mm:ss"
              :picker-options="pickerOptions"
            ></el-date-picker>
          </el-form-item>
          <el-form-item prop="ids">
            <!-- <el-input v-model="searchParam.ids[0]" placeholder="请输入订单编号"></el-input> -->
            <base-input-tag
              style="width:220px"
              v-model="searchParam.ids"
              :placeholder="$lang('请输入订单编号(最多可查100条)')"
              :clearBtnVisible="true"
              :addTagOnBlur="true"
              ref="BaseInputTag1"
              class="cms-input-tag"
            >
            </base-input-tag>
          </el-form-item>
          <el-form-item prop="waybillIds">
            <!-- <el-input v-model="searchParam.waybillIds[0]" placeholder="请输入运单编号"></el-input> -->
            <base-input-tag
              style="width:210px"
              v-model="searchParam.waybillIds"
              :placeholder="$lang('请输入运单编号(最多可查100条)')"
              :clearBtnVisible="true"
              :addTagOnBlur="true"
              ref="BaseInputTag2"
              class="cms-input-tag"
            >
            </base-input-tag>
          </el-form-item>
          <el-form-item prop="customerOrderIds">
            <el-input v-model="searchParam.customerOrderIds[0]" :placeholder="$lang('客户订单号')"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="searchChange" icon="iconfont iconchaxun" class="h32">{{ $lang('查询') }}</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" plain @click="resetSearch" icon="iconfont iconshanchu" class="h32">{{ $lang('清空') }}</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="externalOrder-bottom">
      <div class="tabs-nav">
        <div class="tabs-nav-item" v-for="(item, index) in menuItems" :key="index" @click="changeTab(index)" :class="{ active: tabActive === index }">
          {{ item.orderStatusName }}<span class="tabs-nav-item-count">{{ item.total }}</span>
        </div>
      </div>

      <JmsTableScroll
        ref="table"
        :option="listOpt"
        :data="tableList"
        :page="page"
        :table-loading="loading"
        @size-change="sizeChange"
        :isCheckedAll="isCheckedAll"
        @select-all="handleSelectAll1"
        @select="handleSelectionChange"
        @current-change="currentChange"
      >
        <template slot="orderStatusName" slot-scope="data">
          <span class="dot" :class="data.row.orderStatusName == '待打印' ? 'oragin' : ''" v-show="data.row.orderStatusName == '待打印'">{{ $lang(data.row.orderStatusName) }}</span>
          <span class="dot" :class="data.row.orderStatusName == '已打印' ? 'oragin' : ''" v-show="data.row.orderStatusName == '已打印'">{{ $lang(data.row.orderStatusName) }}</span>
          <span class="dot" :class="data.row.orderStatusName == '已取件' ? 'green' : ''" v-show="data.row.orderStatusName == '已取件'">{{ $lang(data.row.orderStatusName) }}</span>
          <span class="dot" v-show="data.row.orderStatusName == '已取消'">{{ $lang(data.row.orderStatusName) }}</span>
        </template>
        <template slot="receiverName" slot-scope="data">
          <span>{{data.row.receiverName}}</span>
          <span v-mask="{data: {...data.row,apiType:2},  key: 'receiverMobilePhone', type: 'orderPlaintext' }" >/</span>
          <span>{{`/${data.row.receiverProvinceName}/${data.row.receiverCityName}/${data.row.receiverAreaName}/${data.row.receiverDetailedAddress}`}}</span>
        </template>
        <template slot="senderName" slot-scope="data">
          <span>{{data.row.senderName}}</span>
          <span v-mask="{data: {...data.row,apiType:1},  key: 'senderMobilePhone', type: 'orderPlaintext' }" >/</span>
          <span>{{`/${data.row.senderProvinceName}/${data.row.senderCityName}/${data.row.senderAreaName}/${data.row.senderDetailedAddress}`}}</span>
        </template>
        <template slot="menu" slot-scope="data">
          <div>
            <!-- 查看按钮 -->
            <el-button @click="rowView(data.row)" type="text">{{ $lang('查看') }}</el-button>
          </div>
        </template>
      </JmsTableScroll>
    </div>

    <!-- 订单详情弹框组件 -->
    <bullet ref="bullet" v-if="viewDialogVisible" :orderType="orderType" :viewDialogVisible="viewDialogVisible" @closeDetails="closeDetails" :bulletTitle="2" :rowData="rowData"></bullet>
    <!-- 导出订单弹框组件 -->
    <export-componet
      ref="exportComponet"
      :cityOptions="customerOrderOptions"
      :idsLength="multipleSelection.length"
      :exportVisible="exportVisible"
      :exportData="exportData"
      @export-close="exportClose"
      @export-fn="exportFn"
    ></export-componet>

    <!-- 下载中心 -->
    <ExportDownloadDialog :moduleType="moduleType" :dialogExportDownVisible.sync="dialogExportDownVisible"></ExportDownloadDialog>
  </div>
</template>
<script>
import dayjs from 'dayjs'
import JmsTableScroll from '@/components/jms-widget/jms-table-scroll'
import mixin from '@/mixins/mixin.js'
import { orderListThrid, asyExportOrderThrid, orderTotalGroupThrid, detailOrder, queryCustomerOrderSource, printShopify } from '@/api/module/customer'
import bullet from '@components/base/BaseBulletThird.vue'
import exportComponet from '@components/base/BaseExport.vue'
import Print from '@components/jms-widget/print'
import { commonFun } from '@utils/common'
import { RESPONSE_SUCCESS } from '@constants'
import { mapActions } from 'vuex'
import ExportDownloadDialog from '@components/export-download-dialog/ExportDownloadDialog.vue'
export default {
  name: 'ExternalOrders',
  mixins: [mixin],
  components: {
    JmsTableScroll,
    bullet,
    exportComponet,
    Print,
    ExportDownloadDialog
  },
  data() {
    return {
      pickerOptions: {
        disabledDate: (time) => {
          return time.getTime() < dayjs().subtract(90, 'day').endOf('day').valueOf() || time.getTime() > dayjs().endOf('day').valueOf()
        }
      },
      COM_HTTP: {
        reqList: orderListThrid,
        reqExcel: asyExportOrderThrid,
        reqDetail: detailOrder
      },
      isShowFirst: false,
      searchParam: {
        date: commonFun.GetTodayDate(),
        startdate: commonFun.GetTodayDate()[0], // 开始时间，格式：yyyy-MM-dd HH:mm:ss
        enddate: commonFun.GetTodayDate()[1], // 结束时间，格式：yyyy-MM-dd HH:mm:ss
        ids: [], // 订单号
        tabTypeCode: 'wait_print', // 页签（all，already_print，already_pick，already_cancle）
        waybillIds: [],
        customerOrderIds: []
      },
      orderSourceCodeList: [], // 下单渠道
      menuItems: [], // tab菜单
      multipleSelection: [], // 多选或全选数据
      disabled: true, // 禁止点击状态
      exportVisible: false, // 导出弹框显示
      excelParams: {}, // 导出日期条件
      exportStatus: 'wait_print',
      exportType: 1, // 1：订单； 2：运单
      exportData: {},
      selectId: '', // 当前选中的id
      mergeLoading: false, // 合并loading
      printLoading: false, // 打印按钮loading
      exportLoading: false, // 导出loading
      printOptions: {
        btnTitle: this.$lang('面单打印'),
        btnType: 'primary',
        addClass: 'h40'
      },
      isCheckedAll: false,
      isKeyUp: false,
      page: {
        // 分页配置
        current: 1,
        size: 100,
        total: 0,
        sizes: [50, 100, 200, 500, 1000]
      },
      tabActive: 1, // tab 选中
      dialogExportDownVisible: false, // 下载中心
      moduleType: 'web_order', // 我的订单
      orderType: 'thridNo',
      // 第三方订单导出字段
      customerOrderOptions: [
        {
          key: 'id',
          name: this.$lang('订单编号'),
          required: true,
          disabled: true
        },
        {
          key: 'waybillId',
          name: this.$lang('运单编号'),
          required: true,
          disabled: true
        },
        {
          key: 'orderStatusName',
          name: this.$lang('状态'),
          required: true,
          disabled: true
        },
        {
          key: 'orderSourceName',
          name: this.$lang('订单来源'),
          required: true,
          disabled: true
        },
        {
          key: 'printsNumber',
          name: this.$lang('打印次数'),
          required: true,
          disabled: true
        },
        {
          key: 'customerOrderId',
          name: this.$lang('客户订单号'),
          required: true,
          disabled: true
        },
        {
          key: 'customerWaybillNo',
          name: this.$lang('第三方运单号'),
          required: true,
          disabled: true
        },
        {
          key: 'receiverName',
          name: this.$lang('收件人'),
          required: true,
          disabled: true
        },
        {
          key: 'receiverMobilePhone',
          name: this.$lang('收件电话'),
          required: true,
          disabled: true
        },
        {
          key: 'receiverProvinceName',
          name: this.countryCode === 'UAE' ? this.$lang('收件酋长国') : this.$lang('收件省份'),
          required: true,
          disabled: true
        },
        {
          key: 'receiverCityName',
          name: this.countryCode === 'UAE' ? this.$lang('收件区域') : this.$lang('收件城市'),
          required: true,
          disabled: true
        },
        {
          key: 'receiverDetailedAddress',
          name: this.$lang('收件地址'),
          required: true,
          disabled: true
        },
        {
          key: 'receiverCompany',
          name: this.$lang('收件人公司')
        },
        {
          key: 'senderName',
          name: this.$lang('寄件人')
        },
        {
          key: 'senderMobilePhone',
          name: this.$lang('寄件电话')
        },
        {
          key: 'senderProvinceName',
          name: this.countryCode === 'UAE' ? this.$lang('寄件酋长国') : this.$lang('寄件省份')
        },
        {
          key: 'senderCityName',
          name: this.countryCode === 'UAE' ? this.$lang('寄件区域') : this.$lang('寄件城市')
        },
        {
          key: 'senderDetailedAddress',
          name: this.$lang('寄件地址')
        },
        {
          key: 'goodsTypeName',
          name: this.$lang('物品类型')
        },
        {
          key: 'goodsName',
          name: this.$lang('物品名称')
        },
        {
          key: 'packageTotalWeight',
          name: this.$lang('物品重量')
        },
        {
          key: 'declaredValue',
          name: this.$lang('物品价值')
        },
        {
          key: 'insuredValue',
          name: this.$lang('赔偿上限服务费')
        },
        {
          key: 'paymentModeName',
          name: this.$lang('支付方式')
        },
        {
          key: 'standardValue',
          name: this.$lang('参考运费')
        },
        {
          key: 'remarks',
          name: this.$lang('备注')
        },
        {
          key: 'inputTime',
          name: this.$lang('下单时间')
        },
        {
          key: 'pickTime',
          name: this.$lang('取件时间')
        },
        {
          key: 'cancelTime',
          name: this.$lang('取消时间')
        }
      ]
    }
  },
  async created() {
    this.isSinleSelection = []
    // 获取订单来源数据
    const key = this.$route.params.typeNum
    // this.getOrderOrigin(key)
    await this.orderTotalGroupThrid(this.searchParam)
    if (key) {
      this.handleSelect(key)
    } else {
      this.searchFun()
    }
    // this.updateOutExcel(key)
  },
  computed: {
    listOpt() {
      return {
        border: true,
        selection: true,
        menu: true,
        viewBtn: false,
        editBtn: false,
        delBtn: false,
        // rowKey: '$index',
        fixHeight: 90,
        //  搜索框和表格列及其字段
        column: [
          {
            label: '客户订单号',
            prop: 'customerOrderId',
            width: 150
          },
          {
            label: '订单编号',
            prop: 'id',
            width: 150
          },
          {
            label: '运单编号',
            prop: 'waybillId',
            width: 150
          },
          {
            label: '状态',
            prop: 'orderStatusName',
            slot: true
          },
          {
            label: '打印次数',
            prop: 'printsNumber'
          },
          {
            label: '收件方',
            prop: 'receiverName',
            slot: true,
            // formatter: (row, value, label, column) => {
            //   return `${row.receiverName}/${row.receiverMobilePhone}/${row.receiverProvinceName}/${row.receiverCityName}/${row.receiverAreaName}/${row.receiverDetailedAddress}`
            // },
            width: 400
          },
          {
            label: '寄件方',
            prop: 'senderName',
            slot: true,
            // formatter: (row, value, label, column) => {
            //   return `${row.senderName}/${row.senderMobilePhone}/${row.senderProvinceName}/${row.senderCityName}/${row.senderAreaName}/${row.senderDetailedAddress}`
            // },
            width: 400
          },
          {
            label: '物品类型',
            prop: 'goodsTypeName'
          },
          {
            label: '物品名称',
            prop: 'goodsName'
          },
          {
            label: '物品重量',
            prop: 'packageTotalWeight'
          },
          {
            label: '物品价值',
            prop: 'declaredValue'
          },
          {
            label: '产品类型',
            prop: 'expressTypeName'
          },
          {
            label: '结算方式',
            prop: 'paymentModeName'
          },
          {
            label: '支付方式',
            prop: 'paidModeName'
          },
          {
            label: '参考运费',
            prop: 'standardValue',
            show: this.userInfo.freightStatus === 1
          },
          {
            label: '代收货款金额',
            prop: 'codMoney'
          }
        ]
      }
    },
    // 用户信息
    userInfo() {
      return this.$store.state.base.user || {}
    },
    countryCode() {
      return this.$store.state.base.user.countryCode || ''
    },
    countryId() {
      return this.$store.state.base.user.countryId || ''
    }
  },
  watch: {
    tableList: {
      handler(oldVal, newVal) {
        if (this.isKeyUp && this.exportStatus === 'already_print' && this.tableList.length === 1 && this.autoPrint) {
          this.autoPrint = false
          this.multipleSelection = this.tableList
          this.$nextTick(() => {
            this.$refs.table.$refs.table.toggleRowSelection(this.tableList[0], true)
            this.$refs.printOrder && this.$refs.printOrder.$refs.btnPrint.$el.click()
          })
        }
      },
      deep: true
    }
  },
  methods: {
    ...mapActions(['LOGIN_OUT', 'SET_USER', 'UPDATE_PRINT_STOCK']),
    /**
     * @description 复制
     */
    handleCopy(data) {
      const value = data.row.waybillId
      const oInput = document.createElement('input')
      oInput.value = value
      document.body.appendChild(oInput)
      oInput.select() // 选择对象;
      document.execCommand('Copy') // 执行浏览器复制命令
      this.$message({
        message: '运单号复制成功',
        type: 'success'
      })
      oInput.remove()
    },
    // 获取下单渠道下拉数据，请求列表数据
    async getOrderOrigin(key) {
      try {
        const { code, data } = await queryCustomerOrderSource()
        if (code === RESPONSE_SUCCESS) {
          if (data.length) {
            const dataNew = data.filter(item => item.groupOrderSourceCode !== 'D02')
            this.orderSourceCodeList = dataNew
          } else {
            this.orderSourceCodeList = []
          }

          await this.orderTotalGroupThrid(this.searchParam)
          if (key) {
            this.handleSelect(key)
          } else {
            this.searchFun()
          }
        } else {
          this.orderSourceCodeList = []
        }
      } catch (error) {
        this.orderSourceCodeList = []
      }
    },
    // 选择分页条数
    sizeChange(val, list) {
      this.page.current = 1
      this.page.size = val
      this.searchFun()
      this.multipleSelection = []
      this.isCheckedAll = false
    },
    // 跳转页码
    currentChange(val) {
      this.page.current = val
      this.searchFun()
      this.multipleSelection = []
      this.isCheckedAll = false
    },
    handleCompositionEnd(e) {
      // 中文输入法回车事件
      const { data } = e || {}
      if (data.length > 11) {
        this.searchParam.startdate = commonFun.getBeforeDate(30) + ' 00:00:00'
        this.searchParam.enddate = commonFun.GetTodayDate()[1] // 开始时间，格式：yyyy-MM-dd HH:mm:ss
        this.searchParam.date = [this.searchParam.startdate, this.searchParam.enddate]
        this.searchChange()
      }
    },
    toKeyUp(e) {
      if (this.isKeyUp) {
        // 回车搜索后首次输入清空输入框
        this.isKeyUp = false
      }
      return true
    },
    // 获取打印数据
    async getPrintData(type, language) {
      const newArr = this.multipleSelection.map((item, index, selection) => {
        return { customerOrderId: item.customerOrderId, id: item.id, trackingNumber: item.waybillId }
      })
      // const ids = newArr.join(',')
      const params = { orderInfoDTOS: newArr, printType: type, isVip: false, language }
      const res = await printShopify(params)
      if (res.code === RESPONSE_SUCCESS) {
        this.$message.success(this.$lang('已生成打印数据，正在打印中...'))
        // settlementName 到付现结 freight
        this.isCheckedAll = false
        setTimeout(() => {
          this.searchChange()
          // 更新库存面单
          if (this.exportStatus !== 'already_print') {
            this.UPDATE_PRINT_STOCK(true)
          }
        }, 1100)
        return res.data
      } else {
        this.$refs['printOrder'].keyBtn = false
        res.msg && this.$message.error(this.$lang(res.msg))
        return false
      }
      // if (res.type === 'application/pdf') {
      //   window.console.log('application/pdf')
      //   this.$message.success(this.$lang('已生成打印数据，正在打印中...'))
      //   // settlementName 到付现结 freight
      //   this.isCheckedAll = false
      //   setTimeout(() => {
      //     this.searchChange()
      //     // 更新库存面单
      //     if (this.exportStatus !== 'already_print') {
      //       this.UPDATE_PRINT_STOCK(true)
      //     }
      //   }, 1100)
      //   return res
      // } else if (res.type === 'application/json') {
      //   const reader = new FileReader()
      //   reader.readAsText(res)
      //   reader.onload = (event) => {
      //     const msg = JSON.parse(reader.result).msg || '' // 错误信息
      //     this.$message.error(this.$lang(msg))
      //   }
      //   this.$refs['printOrder'].keyBtn = false
      //   return false
      // }
    },

    // 选择日期
    selectDate() {
      const [start = '', end = ''] = this.searchParam.date
      this.searchParam.startdate = start
      this.searchParam.enddate = end
    },
    getParams() {
      console.log(5555555555555)
      const { tabTypeCode, ids } = this.searchParam
      const newIds = ids && ids.length >= 1 && ids[0] === '' ? [] : ids
      const searchParam = Object.assign({}, this.searchParam)
      const arr = ['current', 'size', 'startdate', 'enddate', 'date', 'tabTypeCode', 'columnNames', 'sort', 'orderStatusCode', 'isVip']
      Object.keys(searchParam).forEach(item => {
        if (!arr.includes(item)) {
          if (searchParam[item] instanceof Array && searchParam[item][0]) {
            delete searchParam.startdate
            delete searchParam.enddate
          } else if (typeof searchParam[item] === 'string' && searchParam[item]) {
            delete searchParam.startdate
            delete searchParam.enddate
          }
        }
      })
      searchParam.ids = newIds
      searchParam.tabTypeCode === '0' ? '' : tabTypeCode
      searchParam.isVip = false
      return searchParam
    },
    // 查询
    async searchChange(params) {
      const { startdate, enddate } = this.searchParam
      const space = 31 * 24 * 3600 * 1000
      const startTime = new Date(startdate).getTime()
      const endTime = new Date(enddate).getTime()
      if (endTime - startTime > space) {
        this.$message.error(this.$lang('开始时间与结束时间之差不能大于31天'))
        return
      }
      this.searchParam.tabTypeCode = this.menuItems.length > 0 ? this.menuItems[this.tabActive].orderStatusCode : ''
      // 处理订单编号
      const { ids, waybillIds } = this.searchParam
      if (ids && ids.length !== 0) {
        if (ids.length > 100) {
          return this.$message.warning(this.$lang('请勿超过100条订单'))
        }
        const p_billNo = ids.join(',')
        if (isNaN(p_billNo.replace(/,/g, ''))) {
          return this.$message.error(this.$lang('订单编号为全数字'))
        }
      }
      this.searchParam.customerOrderIds = this.searchParam.customerOrderIds.length > 0 && !this.searchParam.customerOrderIds[0] ? [] : this.searchParam.customerOrderIds
      // 处理运单编号
      if (waybillIds && waybillIds.length !== 0) {
        if (waybillIds.length > 100) {
          return this.$message.warning(this.$lang('请勿超过100条运单'))
        }
      }
      // 列表查询
      await this.searchFun(1)
      // 列表总数查询
      await this.orderTotalGroupThrid(this.searchParam)
      this.multipleSelection = []
    },
    handleSelect(key) {
      const menuItems = this.menuItems
      this.searchParam.tabTypeCode = menuItems[key].orderStatusCode
      this.exportStatus = menuItems[key].orderStatusCode
      this.tabActive = key
      this.currentKey = parseInt(key)
      this.page.current = 1
      this.isCheckedAll = false
      // 重置表格滚动条置顶
      this.$refs.table.$el.querySelector('.el-table__body-wrapper').scrollTop = 0
      this.searchFun()
      // 清空选中数据
      this.multipleSelection = []
      this.autoPrint = false
      // 列表总数查询
      this.orderTotalGroupThrid(this.searchParam)
      this.$nextTick(() => {
        this.$refs.table.$refs.table.doLayout()
      })
    },
    // 取消成功
    cancelSuccess() {
      this.multipleSelection = []
      this.isCheckedAll = false
      setTimeout(() => {
        this.orderTotalGroupThrid(this.searchParam)
        this.searchFun()
      }, 1000)
    },
    // 删除成功回调
    afterDelSuccess() {
      this.cancelSuccess()
    },
    // 打开导出弹框
    async exportOpen() {
      console.log(this.multipleSelection, '打开弹窗前')
      if (this.multipleSelection.length <= 0) {
        this.exportLoading = true
        await this.orderTotalGroupThrid(this.searchParam)
        this.searchFun()
        this.exportLoading = false
        const listTotal = this.menuItems[this.tabActive].total || 0
        if (listTotal <= 0) {
          this.$message.warning(this.$lang('没有可导出的数据'))
          return
        }
        if (listTotal > 10000) {
          this.$message.warning(this.$lang('导出条数不能大于1万条，请重置查询条件'))
          return
        }
      }
      // this.customerOrderOptions = [...customerOrderOptions]
      /**
       * @description 如果设置了 不显示参考运费 删除参考运费
       */
      if (this.userInfo.freightStatus === 0) {
        const chooseIndex = this.customerOrderOptions.findIndex(item => item.name === '参考运费')
        // 删除参考运费选项
        this.customerOrderOptions.splice(chooseIndex, 1)
      }
      // this.updateOutExcel(this.currentKey)
      this.exportVisible = true
      const exportData = {
        exportStatus: this.exportStatus,
        exportType: this.exportType // 1：订单； 2：运单
      }
      this.exportData = exportData
    },
    // 关闭导出弹框
    exportClose(val) {
      this.exportVisible = val
    },
    // 导出-获取参数
    getParamForOutExcel() {
      const sort = []
      const columnNames = []
      let ids = []
      const len = (this.multipleSelection && this.multipleSelection.length) || 0
      if (len) ids = this.multipleSelection.map(item => item.id)
      // 处理导出表格的属性字段
      this.columnList.forEach(item => {
        sort.push(item.key)
        columnNames.push(item.name)
      })
      let params = { sort, columnNames, tabTypeCode: this.exportStatus }
      if (len) params = { ...params, ids, isVip: false }
      else {
        params = { ...params, ...this.searchParam }
      }
      const arr = ['current', 'size', 'startdate', 'enddate', 'date', 'tabTypeCode', 'columnNames', 'sort', 'isVip']
      Object.keys(params).forEach(item => {
        if (!arr.includes(item)) {
          if (params[item] instanceof Array && params[item][0]) {
            delete params.startdate
            delete params.enddate
          } else if (typeof params[item] === 'string' && params[item]) {
            delete params.startdate
            delete params.enddate
          }
        }
      })
      return params
    },
    // 导出数据
    async exportFn(bool, data, dataParams) {
      this.exportVisible = bool
      this.columnList = data
      this.excelParams = dataParams
      // await this.outExcel()
      //   改为异步导出
      await this.asyExportOrder()
    },
    async asyExportOrder() {
      const param = this.getParamForOutExcel()
      // 调用导出api
      const { code, msg } = await this.COM_HTTP.reqExcel(param)
      if (code === RESPONSE_SUCCESS) {
        this.$message.success(this.$lang('导出成功，请到下载中心查看'))
      } else {
        this.$message.error(msg)
      }
    },
    // 更新导出参数配置
    updateOutExcel(key = 0) {
      // cityOptions
      const inputTime = {
        key: 'inputTime',
        name: '下单时间'
      }
      const pickTime = {
        key: 'pickTime',
        name: '取件时间'
      }
      const cancelTime = {
        key: 'cancelTime',
        name: '取消时间'
      }
      //   const printTime = {
      // key: 'printTime',
      // name: '打印时间',
      //   }
      this.customerOrderOptions.push(inputTime, pickTime, cancelTime)
    },
    // 获取tabs
    async orderTotalGroupThrid(reqData) {
      // 状态数据统计
      reqData.isVip = false
      const params = this.getParams()
      const { code, data } = await orderTotalGroupThrid(params)
      if (code === RESPONSE_SUCCESS) {
        const list = [...data]
        if (list.length > 0 && list[0].total === 0 && this.isKeyUp) {
          this.$message.warning('查询不到订单信息')
        }
        this.menuItems = list
      }
    },
    // 查看
    async rowView(row) {
      this.selectId = row.id
      // 获取查看详情
      await this.viewFun(row)
      this.viewDialogVisible = true
    },
    // close:关闭；delWaybill删除运单  ； cancelOrder:取消订单； ediOrder:编辑订单 delOrder:删除订单；
    closeDetails(val) {
      this.viewDialogVisible = val.viewDialogVisible
      switch (val.type) {
        case 'cancelOrder':
          this.$refs.cancelOrder.dialogTableVisible = true
          break
        case 'ediOrder':
          this.editDialogVisible = true
          break
        case 'delOrder':
          const item = {
            orderId: val.rowData.id
          }
          this.rowDel(item)
          break
      }
    },
    // 重置编辑表单
    clearFormItem() {
      this.$refs['editOrder'].$refs['orderForm'].resetFields()
    },
    printDialogClode() {
      this.printTableVisible = false
    },
    // 重置搜索
    resetSearch() {
      this.searchParam = {
        ids: [],
        date: commonFun.GetTodayDate(),
        startdate: commonFun.GetTodayDate()[0], // 开始时间，格式：yyyy-MM-dd HH:mm:ss
        enddate: commonFun.GetTodayDate()[1], // 结束时间，格式：yyyy-MM-dd HH:mm:ss
        waybillIds: [],
        customerOrderIds: []
      }
      this.$refs.BaseInputTag1.clearFn()
      this.$refs.BaseInputTag2.clearFn()
    },
    // 全选
    handleSelectAll1(val) {
      this.multipleSelection = val
      this.originSelectionAll = [...val]
      if (val.length) {
        this.isCheckedAll = true
      } else {
        this.isCheckedAll = false
      }
    },
    // 单个选中
    handleSelectionChange(val, currentRow) {
      // 检测当前行的选中状态
      const isChecked = val.some(item => item.id === currentRow.id)
      if (this.isCheckedAll) {
        if (!isChecked) {
          this.isSinleSelection = [...(this.isSinleSelection || []), currentRow.id]
        } else {
          this.isSinleSelection = this.isSinleSelection.filter(item => item !== currentRow.id)
        }
        this.multipleSelection = this.originSelectionAll.filter(item => !this.isSinleSelection.includes(item.id))
      } else {
        this.multipleSelection = val
      }
    },
    changeTab(index) {
      this.tabActive = index
      this.handleSelect(index)
    },
    /**
     * 去快件查询
     */
    getExpressTracking(waybillId) {
      this.$router.push({ path: '/expressTracking', query: { waybillId }})
    }
  }
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0;
}
.el-menu-item {
  height: 32px;
  line-height: 32px;
  padding: 0 3px;
  margin: 0 20px;
  text-align: center;
}
.el-menu-item:first-of-type {
  padding-left: 0;
  margin-left: 0;
  text-align: left;
}
input {
  font-size: 12px !important;
}
.externalOrder {
  .externalOrder-top {
    padding: 16px 24px;
    .commonSize {
      width: 328px !important;
      height: 32px !important;
    }
  }
  .externalOrder-bottom {
    padding: 12px 24px;
    flex: 1;
    display: flex;
    flex-direction: column;
    background: #edeef3;
    box-sizing: border-box;
  }

  .search-btns {
    margin-bottom: 10px;
  }
  .tabs-nav {
    // margin: 5px 0 9px;
    .tabs-nav-item {
      display: inline-block;
      line-height: 1;
      white-space: nowrap;
      cursor: pointer;
      background: #fff;
      border: 1px solid #dcdfe6;
      -webkit-appearance: none;
      text-align: center;
      box-sizing: border-box;
      outline: none;
      margin: 0;
      transition: 0.1s;
      font-weight: 500;
      -moz-user-select: none;
      -webkit-user-select: none;
      -ms-user-select: none;
      padding: 12px 20px;
      font-size: 16px;
      background: #e0e1e7;
      height: 40px;
      border: 0;
      background: #e0e1e7;
      border-radius: 8px 8px 0 0;
      color: #666;
      margin-left: 10px;
      &:first-of-type {
        margin-left: 0px;
      }
      i {
        margin-right: 8px;
        color: #666;
      }
      &.active {
        background: #fff;
        color: #e60012;
        i {
          color: #e60012;
        }
      }
    }
    .tabs-nav-item-count {
      display: inline-block;
      width: 35px;
      height: 20px;
      font-size: 12px;
      line-height: 20px;
      background: rgba(102, 102, 102, 0.1);
      border-radius: 10px;
      margin-left: 5px;
    }
  }
}
</style>
<style lang="scss">
.externalOrder .externalOrder-top .el-input__inner {
  margin-bottom: 10px;
}
.customerWaybillNos .el-input__inner {
  margin-bottom: 0px !important;
}
</style>
